import { useContext } from 'react';
import { SecureExamContext, disabledSecureExamValue } from './secureExamContext';

export function useSecureExam() {
  const ctx = useContext(SecureExamContext);
  return ctx || disabledSecureExamValue;
}
